const messages = require('./en.json');
const xingMessages = require('./xing/en.json');

module.exports = {
  locales: ['en'],
  messages: { ...xingMessages, ...messages },
};
